module.exports = __webpack_public_path__ + "static/media/status-done.45e3ae51.svg";